import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as Actions from "../../../constants/baseUrl";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const emailParam = query.get("email") || "";
    // Replace any spaces that may have been introduced in email containing '+'
    setEmail(emailParam?.replace(/\s+/g, "+"));
    setToken(query.get("token") || "");
  }, [query]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${Actions.AUTH_URL}Users/reset-password`,
        {
          email,
          token,
          newPassword,
        }
      );
      toast.success(
        response.data?.message ||
          "Please use new password to login to your account."
      );
      navigate("/my-profile");
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-5 pt-5 demosAddFormSection">
      <div className="formWrap row mx-0 mt-5">
        <Form
          onSubmit={handleSubmit}
          className="col-lg-6 col-md-10 demosAddForm"
        >
          <div className="col-12  py-3">
            <h3 className="theme-text" id="tabelLabel">
              Reset Password
            </h3>
          </div>

          <h6 className="text-start">
            We have received a request to reset your password.
          </h6>
          <h6 className="theme-text-2 text-start">
            Enter a new password to reset your account.
          </h6>

          <Form.Group className="form-floating formfloating mb-3">
            <Form.Control
              className="form-control fromcontrol"
              type="password"
              id="newPassword"
              label="New Password"
              placeholder="New Password"
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <Form.Label htmlFor="newPassword">New Password</Form.Label>
          </Form.Group>
          <Button
            className="btn add-button px-4 float-end mb-3"
            type="submit"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
